import React from "react";
import preview from "../../../assets/portfolio/scarletpearl/preview.png";

export default function ScarletPearl() {
	return (
		<div
			style={{ margin: "0 2rem", marginTop: "1rem", width: "calc(50% - 4rem)" }}
			data-aos="fade-up">
			<h2
				style={{
					fontWeight: 400,
					fontSize: "16px",
					lineHeight: "16px",
					margin: "1rem 0",
				}}>
				Scarlet Pearl Casino{" "}
			</h2>
			<h3>Multiple Time-limited Microsites</h3>
			<p>
				Custom microsites built using VanillaJS. Sites matched theme of event or
				promotion.
			</p>
			<div
				style={{
					width: "100%",
					height: "600px",
					overflow: "hidden",
					borderRadius: "10px",
					paddingLeft: "2rem",
					paddingTop: "2rem",
					backgroundColor: "#252424",
				}}>
				<img
					src={preview}
					alt="Scarlet Pearl Casino Microsites"
					style={{ height: "100%" }}
				/>
			</div>
		</div>
	);
}
